import { Component, OnDestroy } from '@angular/core';
import { LanguageService } from '../../../language/services/language.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnDestroy {
  private notifier = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private language: LanguageService,
    private router: Router,
    private title: Title,
    private translate: TranslateService
  ) {
    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant('modules.evSimulator.general.title'));
    });
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  getImageUrl(): string {
    // There is an image for each language
    return 'assets/evc/img/not-found/not-found-' + this.language.getLanguage() + '.svg';
  }

  goBack(): void {
    if (this.route.snapshot.queryParams.id) {
      // If id is present, we navigate the user to evc-quote (user is navigated to the last reached step automatically)
      this.router.navigateByUrl(
        '/' + this.language.getLanguage() + '/evc-quote/car-details?id=' + this.route.snapshot.queryParams.id
      );
    } else {
      this.router.navigate(['/' + this.language.getLanguage() + '/ev-simulator']);
    }
  }

  startAgain(): void {
    this.router.navigate(['/' + this.language.getLanguage() + '/ev-simulator']);
  }
}
